<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">Options
        <span class="caret"></span></button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} &amp; exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div v-if="tab === 'main'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label for="rr-desc" class="form-label">Description</label>
              <input type="text" class="form-control" id="rr-desc" v-model="entity.description"/>
            </div>
            <div class="form-group">
              <label class="form-label">Origin Location</label>
              <autocomplete
                  :dataset="locationSearchResults"
                  title="Origin Location"
                  placeHolder="Type to search"
                  :initVal="entity.originLocation"
                  v-on:changing="data => locationSearchText = data"
                  :fnFormatText="displayLocation"
                  :fnSelectValue="displayLocation"
                  v-on:selection-made="selectOrigin" />
            </div>
            <div class="form-group">
              <label for="origin-state" class="form-label">Origin State</label>
              <input type="text" class="form-control" id="origin-state" v-model="entity.originState"/>
            </div>
            <div class="form-group">
              <label for="not-origin-state" class="form-label">Not Origin State</label>
              <input type="text" class="form-control" id="not-origin-state" v-model="entity.notOriginState"/>
            </div>
            <div class="form-group">
              <label for="rr-oc" class="form-label">Origin Country</label>
              <select v-model="entity.originCountry" class="form-control" id="rr-oc">
                <option value=""></option>
                <option v-for="(opt, i) in countries" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="destination-state" class="form-label">Destination State</label>
              <input type="text" class="form-control" id="destination-state" v-model="entity.destinationState"/>
            </div>
            <div class="form-group">
              <label for="not-destination-state" class="form-label">Not Destination State</label>
              <input type="text" class="form-control" id="not-destination-state" v-model="entity.notDestinationState"/>
            </div>
            <div class="form-group">
              <label class="form-label">Destination Location</label>
              <autocomplete
                :dataset="locationSearchResults"
                title="Destination Location"
                placeHolder="Type to search"
                :initVal="entity.destinationLocation"
                v-on:changing="data => locationSearchText = data"
                :fnFormatText="displayLocation"
                :fnSelectValue="displayLocation"
                v-on:selection-made="selectDestination" />
            </div>
            <div class="form-group">
              <label for="rr-dc" class="form-label">Destination Country</label>
              <select v-model="entity.destinationCountry" class="form-control" id="rr-dc">
                <option value=""></option>
                <option v-for="(opt, i) in countries" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
            <div class="form-group">
              <label for="rr-service" class="form-label">Service Provided</label>
              <select v-model="entity.serviceProvided" class="form-control" id="rr-service">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('SERVICE_PROVIDED')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="rr-serviceT" class="form-label">Service Type</label>
              <select v-model="entity.serviceType" class="form-control" id="rr-serviceT">
                <option value=""></option>
                <option v-for="(opt, i) in serviceTypes" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label class="form-label">Job Type</label>
              <autocomplete
                :dataset="jobTypeSearchResults"
                title="Job Type"
                placeHolder="Type to search"
                :initVal="entity.jobType"
                v-on:changing="data => jobTypeText = data"
                :fnFormatText="displayJobType"
                :fnSelectValue="displayJobType"
                v-on:selection-made="selectJobType"
              ></autocomplete>
            </div>
            <div class="form-group">
              <label for="job-type-contains" class="form-label">When Job Type Contains This Text</label>
              <input type="text" class="form-control" id="job-type-contains" v-model="entity.jobTypeContains"/>
            </div>
            <hr />
            <div class="form-group">
              <label class="form-label">Force Vendor</label>
              <autocomplete
                :dataset="partySearchResults"
                title="Force Vendor"
                placeHolder="Type to search"
                :initVal="entity.forceVendor"
                v-on:changing="data => partySearchText = data"
                :fnFormatText="displayParty"
                :fnSelectValue="displayParty"
                v-on:selection-made="selectVendor"
              ></autocomplete>
            </div>
            <div class="form-group">
              <label class="form-label">Force Location 1</label>
              <autocomplete
                :dataset="locationSearchResults"
                title="Force Location 1"
                placeHolder="Type to search"
                :initVal="entity.forceLocation1"
                v-on:changing="data => locationSearchText = data"
                :fnFormatText="displayLocation"
                :fnSelectValue="displayLocation"
                v-on:selection-made="selectForceLocation1"
              ></autocomplete>
            </div>
            <div class="form-group">
              <label class="form-label">Force Location 2</label>
              <autocomplete
                :dataset="locationSearchResults"
                title="Force Location 2"
                placeHolder="Type to search"
                :initVal="entity.forceLocation2"
                v-on:changing="data => locationSearchText = data"
                :fnFormatText="displayLocation"
                :fnSelectValue="displayLocation"
                v-on:selection-made="selectForceLocation2"
              ></autocomplete>
            </div>
            <div class="form-group">
              <label for="drop-st" class="form-label">Drop Service Type?</label>
              <div class="material-switch">
                <input id="drop-st" type="checkbox" v-model="entity.dropServiceType"/>
                <label for="drop-st" class="label-success"></label>
              </div>
            </div>
            <div class="form-group">
              <label for="add-st" class="form-label">Add Service Type?</label>
              <div class="material-switch">
                <input id="add-st" type="checkbox" v-model="entity.addServiceType"/>
                <label for="add-st" class="label-success"></label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  import Autocomplete from '../../../helpers/AutoComplete.vue'
  import API from '../../../../api/endpoints'
  export default {
    name: 'RoutingRule',
    mixins: [AdminEntityMixin, HelperMixin],
    components: {
      Autocomplete
    },
    data () {
      return {
        transformForUpdate: {
          originCountry: this.toMinus,
          destinationCountry: this.toMinus,
          originLocation: this.toMinus,
          destinationLocation: this.toMinus,
          jobType: this.toMinus,
          serviceProvided: this.toMinus,
          serviceType: this.toMinus,
          forceVendor: this.toMinus,
          forceLocation1: this.toMinus,
          forceLocation2: this.toMinus
        },
        jobTypeText: '',
        jobTypeSearchResults: [],
        newEntityScreen: 'Admin - Routing Rules',
        editEntityScreen: 'Admin - Edit/View Routing Rule',
        tab: 'main',
        boxes: [
          {
            prop: 'originCountry',
            id: 'id'
          },
          {
            prop: 'destinationCountry',
            id: 'id'
          },
          {
            prop: 'serviceProvided',
            id: 'id'
          },
          {
            prop: 'serviceType',
            id: 'id'
          }
        ],
        entity: {
          id: null,
          description: null,
          originCountry: null,
          originState: null,
          notOriginState: null,
          originLocation: null,
          destinationCountry: null,
          destinationState: null,
          notDestinationState: null,
          destinationLocation: null,
          jobType: null,
          jobTypeContains: null,
          serviceProvided: null,
          serviceType: null,
          forceVendor: null,
          forceLocation1: null,
          forceLocation2: null,
          addServiceType: null,
          dropServiceType: null
        },
        entityName: 'routing-rules'
      }
    },
    computed: {
      isValid () {
        return this.entity.description && this.entity.description.trim().length
      },
      serviceTypes () {
        return this.$store.getters['systemOption/serviceTypes']
      }
    },
    watch: {
      jobTypeText (newVal, oldVal) {
        if (newVal.trim().length > 1) {
          this.updateJobTypeSearchResults(newVal)
        }
      }
    },
    methods: {
      updateJobTypeSearchResults (str) {
        this.$http.get(API.GET_ADMIN_ENTITY_BY_FULL_SEARCH('job-type'), { params: { name: str } })
          .then(({data}) => {
            if (str === this.jobTypeText) {
              this.jobTypeSearchResults = data
            }
          })
          .catch((err) => {
            console.log(err)
          })
      },
      selectVendor (v) {
        this.entity.forceVendor = v
        this.partySearchText = ''
        this.partySearchResults = []
      },
      selectJobType (jt) {
        this.entity.jobType = jt
        this.jobTypeText = ''
        this.jobTypeSearchResults = []
      },
      displayJobType (jt) {
        return jt.name
      },
      selectOrigin (l) {
        this.entity.originLocation = l
        this.locationSearchResults = []
        this.locationSearchText = ''
      },
      selectDestination (l) {
        this.entity.destinationLocation = l
        this.locationSearchResults = []
        this.locationSearchText = ''
      },
      selectForceLocation1 (l) {
        this.entity.forceLocation1 = l
        this.locationSearchResults = []
        this.locationSearchText = ''
      },
      selectForceLocation2 (l) {
        this.entity.forceLocation2 = l
        this.locationSearchResults = []
        this.locationSearchText = ''
      },
      getBaseData () {
        return {
          id: null,
          description: null,
          originCountry: null,
          originState: null,
          notOriginState: null,
          originLocation: null,
          destinationCountry: null,
          destinationState: null,
          notDestinationState: null,
          destinationLocation: null,
          jobType: null,
          jobTypeContains: null,
          serviceProvided: null,
          serviceType: null,
          forceVendor: null,
          forceLocation1: null,
          forceLocation2: null,
          addServiceType: null,
          dropServiceType: null
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// RoutingRule.vue?403460f3